/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorSubscriptionDetails as ResolvedLabradorSubscriptionDetails } from 'base/components/labrador/SubscriptionDetails';

export const LabradorSubscriptionDetails: typeof ResolvedLabradorSubscriptionDetails = withLabradorInstanceof((props) => {
    return <ResolvedLabradorSubscriptionDetails {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorSubscriptionDetailsProps = PropsFromComponent<typeof LabradorSubscriptionDetails>;
